import { useEffect } from 'react';

export const AccessibilityWidget: React.FC = () => {
  useEffect(() => {
    // Step 1: Load jQuery
    const jqueryScript = document.createElement('script');
    jqueryScript.src = 'assets/js/jquery-3.7.1.min.js';
    jqueryScript.type = 'text/javascript';
    jqueryScript.async = true;

    let accessScript: HTMLScriptElement;
    let configScript: HTMLScriptElement;

    // Step 2: After jQuery loads, load accessibility script
    jqueryScript.onload = () => {
      accessScript = document.createElement('script');
      accessScript.src = 'https://www.negishim.com/accessibility/accessibility_pro_group255.js';
      accessScript.type = 'text/javascript';
      accessScript.async = true;
      document.body.appendChild(accessScript);

      // Step 3: After accessibility script loads, configure it
      accessScript.onload = () => {
        configScript = document.createElement('script');
        configScript.type = 'text/javascript';
        configScript.innerHTML = `
          pixel_from_side = ${window.innerWidth < 769 ? 70 : window.innerWidth <= 1025 ? 220 : 300};
          pixel_from_start = ${window.innerWidth < 769 ? 20 : 32};
        `;
        document.body.appendChild(configScript);
      };
    };

    document.body.appendChild(jqueryScript);

    // Cleanup
    return () => {
      document.body.removeChild(jqueryScript);
      if (accessScript) document.body.removeChild(accessScript);
      if (configScript) document.body.removeChild(configScript);
    };
  }, []);

  return <></>;
};
